// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3eQv8","ranges":"BmiRanges_ranges__1IgXt"};